import { mixed, number, object, string } from 'yup'

const MAIN_REQUIRED = 'Main Site or Main Provider is required'
const SITE_REQUIRED = 'Site is required when comparing by Main Provider'

/**
 * The position analyzer is meaningless without a reference brand: every KPI
 * (rank, price index, gaps) is computed against the main site or provider, so
 * one of the two is mandatory.
 *
 * `.test` is used instead of `.required()` because `siteMainID` starts as an
 * empty string, which `mixed().required()` would let through.
 */
const requireMain = otherField => mixed().nullable().test(
	'main-site-or-provider',
	MAIN_REQUIRED,
	function (value) {
		return !!value || !!this.parent?.[otherField]
	}
)

/**
 * `siteID` is only mandatory in Main Provider mode, where the analyzer ranks the
 * provider inside one non-direct web. The signal can hold `null`, an array or a
 * scalar depending on the selector mode, and `[]` is truthy — hence the explicit
 * emptiness check.
 */
const requireSite = isProviderMode => mixed().nullable().test(
	'site-required-by-provider',
	SITE_REQUIRED,
	value => {
		if (!isProviderMode) return true

		return Array.isArray(value) ? !!value.length : !!value
	}
)

export const positionSchema = (searchID, isProviderMode = false) => object({
	...!searchID && { officePickupID: number().required('Offices is required') },
	currency: string().required('Currency is required'),
	lor: string().required('Length of Rental is required'),
	siteMainID: requireMain('providerMainID'),
	providerMainID: requireMain('siteMainID'),
	siteID: requireSite(isProviderMode),
})
